// The requests the web sends an Idempotency-Key with: the ones the server
// keys (KEYED_ROUTES in server/idempotency.js), which email a client or move
// money. Paths only, so the query string of an id can't matter. Pure, so
// test/keyed-paths.test.mjs holds it to the server's list: a route keyed
// there and not here is refused with a 400 on every press.
//
// Booking a visit (POST /jobs/:id/visits) and moving or changing one (POST
// /visits/:id) email the client (ADR-039), so they are keyed too; Start,
// Finish and Delete (/visits/:id/start and the rest) are not.
// A quote's deposit moves money too (ADR-053): Record deposit and Refund
// deposit (/quotes/:id/deposit and /quotes/:id/deposit/refund).
// A recurring schedule's Send now and Retry email an invoice there and then
// (/schedules/:id/run-now and /schedules/:id/retry).
const KEYED_PATH = /^\/(?:(?:invoices|quotes|credit-notes)\/[^/?#]+\/(?:send|resend|schedule-send|record-payment|record-refund|mark-paid|refund|write-off|void|deposit|deposit\/refund)|jobs\/[^/?#]+\/visits|visits\/[^/?#]+|schedules\/[^/?#]+\/(?:run-now|retry))(?:[?#]|$)/;

/** Whether a request carries an Idempotency-Key: one per call, a call being one click. */
export function needsIdempotencyKey(method, path) {
  return String(method || "GET").toUpperCase() === "POST" && KEYED_PATH.test(String(path || ""));
}
